import { useQuery } from '@tanstack/react-query';
import i18next from 'i18next';
import { getRegisterCountries } from '../services/apiCountry';

export function getCountryDial(country) {
    return String(country?.dial || country?.phone || '').replace(/\D/g, '');
}

export function getCountryIso(country) {
    return String(country?.iso || country?.code || '').toUpperCase();
}

export function findCountryByDial(countries = [], dial) {
    const value = String(dial || '').replace(/\D/g, '');
    if (!value) return null;
    return countries.find((country) => getCountryDial(country) === value) || null;
}

export function normalizeRegisterCountries(payload) {
    const list = Array.isArray(payload?.data) ? payload.data : [];
    return list.flatMap((item) => {
        const name = String(item?.name || '').trim();
        const iso = String(item?.country_code || '').trim().toUpperCase();
        const dial = String(item?.phone_code || '').replace(/\D/g, '');
        if (item?.id == null || item?.id === '' || !name || !iso || !dial) return [];
        return [{ id: String(item.id), name, iso, dial }];
    });
}

export function useRegisterCountries() {
    const lng = i18next.language;
    const { data, isLoading, isError } = useQuery({
        queryKey: ['register-countries', lng],
        queryFn: getRegisterCountries,
        retry: false,
    });

    const countries = normalizeRegisterCountries(data);
    return { countries, isLoading, isError };
}
